import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    generateUsername(prefix: string = 'user'): string {
        const timestamp = Date.now().toString();                     // 13 digits
        const randomSuffix = Math.random().toString(36).substring(2, 8); // ~6 chars (a-z0-9)
        const username = `${prefix}${randomSuffix}${timestamp}`;  // e.g., "user_k8g9xp_1729468123456"

        return username.length > 50 ? username.substring(0, 50) : username;
    }
}
